import { GYPSUM } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { useAppSelector } from '../../../reducers';
import { planBuilderProductConfigurationsSelector } from '../../../selectors/PlanBuilderSelectors';
import { filteredProductConfigurationsForShoppingCartTBOnlySelector, shouldIncludeLineItemTBSelector, skuIdIsOrHasHubSelector } from '../../../selectors/ProductsSelectors';
import CoreSeatsPickerForPlanBuilder from '../CoreSeatsPickerForPlanBuilder';
import ShoppingCartItem from './ShoppingCartItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeaderContainer = styled.div.withConfig({
  displayName: "ShoppingCartContainer__HeaderContainer",
  componentId: "k36y7o-0"
})(["display:flex;margin-bottom:10px;font-weight:500;font-size:14px;"]);
export const StyledContainer = styled.div.withConfig({
  displayName: "ShoppingCartContainer__StyledContainer",
  componentId: "k36y7o-1"
})(["background-color:", ";padding:16px 24px;position:relative;&:not(:last-child){margin-bottom:8px;}"], GYPSUM);
const ShoppingCartContainer = ({
  className,
  allowRemoveCartItems = true
}) => {
  const productConfigurations = useAppSelector(planBuilderProductConfigurationsSelector);
  const selectedAnyHubs = useAppSelector(state => {
    return productConfigurations.some(productConfiguration => skuIdIsOrHasHubSelector(state, {
      skuId: productConfiguration.skuId
    }));
  });
  const {
    paidCoreSeatProductConfigs,
    paidSalesServiceSeatProductConfigs,
    hubProductConfigs,
    nonSuiteProductConfigs
  } = useAppSelector(state => {
    return filteredProductConfigurationsForShoppingCartTBOnlySelector(state, {
      productConfigurations
    });
  });
  const [filteredNonSuiteProductConfigs, filteredPaidCoreSeatProductConfigs, filteredHubProductConfigs, filteredPaidSalesServiceSeatProductConfigs] = useAppSelector(state => [nonSuiteProductConfigs.filter(config => shouldIncludeLineItemTBSelector(state, Object.assign({}, config))), paidCoreSeatProductConfigs.filter(config => shouldIncludeLineItemTBSelector(state, Object.assign({}, config))), hubProductConfigs.filter(config => shouldIncludeLineItemTBSelector(state, Object.assign({}, config))), paidSalesServiceSeatProductConfigs.filter(config => shouldIncludeLineItemTBSelector(state, Object.assign({}, config)))]);
  const [filteredNonSuiteSkuIds, filteredPaidCoreSeatSkuIds, filteredHubSkuIds, filteredPaidSalesServiceSeatSkuIds] = [filteredNonSuiteProductConfigs.map(({
    skuId
  }) => skuId), filteredPaidCoreSeatProductConfigs.map(({
    skuId
  }) => skuId), filteredHubProductConfigs.map(({
    skuId
  }) => skuId), filteredPaidSalesServiceSeatProductConfigs.map(({
    skuId
  }) => skuId)];
  const showPaidCoreSeats = filteredPaidCoreSeatSkuIds.length > 0 || selectedAnyHubs;
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx(HeaderContainer, {
      style: {
        justifyContent: 'center'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.shoppingCart.yourProducts"
      })
    }), filteredHubSkuIds.map(skuId => /*#__PURE__*/_jsx(ShoppingCartItem, {
      skuId: skuId,
      isCloseable: allowRemoveCartItems
    }, skuId)), showPaidCoreSeats && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HeaderContainer, {
        style: {
          justifyContent: 'center'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'planBuilder.shoppingCart.yourSeats'
        })
      }), /*#__PURE__*/_jsx(StyledContainer, {
        "data-selenium-class": "shopping-cart-item-container",
        children: /*#__PURE__*/_jsx(CoreSeatsPickerForPlanBuilder, {})
      }), filteredPaidSalesServiceSeatSkuIds.map(skuId => /*#__PURE__*/_jsx(ShoppingCartItem, {
        skuId: skuId,
        isCloseable: allowRemoveCartItems
      }, skuId))]
    }), filteredNonSuiteSkuIds && !!filteredNonSuiteSkuIds.length && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HeaderContainer, {
        style: {
          justifyContent: 'center'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.shoppingCart.addOnsAndServices"
        })
      }), filteredNonSuiteSkuIds.map(skuId => /*#__PURE__*/_jsx(ShoppingCartItem, {
        skuId: skuId,
        isCloseable: allowRemoveCartItems
      }, skuId))]
    })]
  });
};
export default ShoppingCartContainer;